import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'

// Components
import CoverImage from '../../../coverimage/CoverImage'

// CSS
import './ExhibitionElement.css'

class ExhibitionElement extends Component {

    static propTypes = {
        exhibition: PropTypes.object.isRequired,
    }

    render() {
        return (
            <li className="exhibition-overview-item">
                <Link to={'/exhibitions/' + this.props.exhibition.url}>
                    <h3>{this.props.exhibition.title}</h3>
                    <CoverImage
                        image={this.props.exhibition.cover_image}
                        title={this.props.exhibition.title}
                    />
                </Link>
                <div dangerouslySetInnerHTML={{ __html: this.props.exhibition.body_text}} />
                <div className="posted-item">From: {moment(this.props.exhibition.start_date).format('DD-MM-YYYY HH:mm')} - {moment(this.props.exhibition.end_date).format('DD-MM-YYYY HH:mm')}</div>
            </li>
        )

    }
}

export default ExhibitionElement;


// WEBPACK FOOTER //
// ./src/components/main/exhibition/exhibitionelement/ExhibitionElement.js